<script>
  import InputComponent from "./Input.svelte";

  export let Inputs = [];
</script>

<div class="table">
  {#each Inputs as Input}
    <InputComponent Input={Input}/>
  {/each} 
</div>

<style>
  .table {
    padding: 2% 3%;

    display: flex;
    flex-direction: column;
  }
</style>